<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">
      Expediente de la constitución
    </h4>

    <div class="container-fluid">
      <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi"
        size="xl">
        <ModalPreviewImg :currentDocumento="currentDocumento" />
      </b-modal>
      <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf"
        size="xl">
        <ModalPreviewPDF :currentDocumento="currentDocumento" />
      </b-modal>
      <b-modal no-close-on-backdrop centered ref="documento-modal-preview-docx" title="" hide-footer id="modaldd"
        size="xl">
        <ModalPreviewDocx :currentDocumento="currentDocumento" />
      </b-modal>
      <b-modal no-close-on-backdrop centered ref="documento-modal-preview-video" title="" hide-footer id="modalvideo"
        size="xl">
        <ModalPreviewVideo :currentDocumento="currentDocumento" />
      </b-modal>
      <!-- <h4 class="cardD">Accionistas</h4> -->

      <div class="row"></div>

      <b-table hover :fields="fields" :items="constitutiva.documentos">
        <template #cell(index)="{ index }">
          {{ getIndex(index + 1) }}
        </template>
        <template #cell(tipo)="{ item }">
          <div v-if="item.tipo === 'Otro'">
            <div v-b-tooltip.hover :title="item.descripcion">
              {{ item.tipo }}
            </div>
          </div>
          <div v-else-if="item.descripcion === 'Factura PDF'">
            {{ item.descripcion }}
          </div>
          <div v-else-if="item.descripcion === 'Factura XML'">
            {{ item.descripcion }}
          </div>
          <div v-else>
            {{ item.tipo }}
          </div>
        </template>
        <template #cell(acciones)="{ item }">
          <b-button v-if="item.documento" variant="primary" size="sm" v-b-tooltip.hover title="Vista previa"
            @click="previewDocumento(item)" class="editBtn" :hidden="item.disabled">
            <b-icon-eye />
          </b-button>
          <b-button v-if="item.documento" variant="success" size="sm" title="Descarga documento"
            @click="descargaFile(item.documento)" :disabled="constitutiva.disabledExpediente">
            <i class="fa fa-download"></i>
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="mt-4">
      <div class="row">
        <!-- <div class="col-10">
          <b-button type="submit" class="btn-fill orange-btn bottom2" size="m"
            :disabled="constitutiva.disabledDocumentos">Guardar</b-button>
        </div> -->
        <b-button class="btn-fill green-btn bottom1" size="m" @click="descargarExpedienteHandler">Descargar expediente</b-button>
        <div class="col-2 ml-auto">
          <b-button variant="success" class="btn-fill" size="m" :disabled="constitutiva.disabledDocumentos"
            @click="validar()">Validar</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";
import ModalPreviewDocx from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewDocx.vue";
import ModalPreviewVideo from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewVideo.vue";

import { FuncionesApi } from "@/api";
import config from "@/config";

export default {
  name: "TabExpediente",

  props: {
    constitutiva: { type: Object }
  },

  components: {
    ModalPreviewImg,
    ModalPreviewPDF,
    ModalPreviewDocx,
    ModalPreviewVideo
  },

  created() {
    this.setDisabled();
  },

  computed: {
    fields() {
      let fields = [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreFile", label: "Nombre", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        // { key: "nombre", label: "Persona Física", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" }
      ];
      return fields;
    }
  },

  data() {
    return {
      loading: false,

      currentDocumento: null,
      currentDocumentoId: null,

      stgAccessKey: config.CD_STG_ACCESS_KEY
    };
  },

  methods: {
    getIndex(index) {
      // return index + (this.currentPage - 1) * this.perPage;
      return index + (1 - 1) * this.constitutiva.documentos.length;
    },

    setDisabled() {
      for (let i = 0; i < this.constitutiva.documentos.length; i++) {
        const pretipoDocumento = this.constitutiva.documentos[i].nombreFile.split(".");
        const tipoDocumento = pretipoDocumento[pretipoDocumento.length - 1];

        if (
          // tipoDocumento == "docx" ||
          tipoDocumento == "pdf" ||
          tipoDocumento == "jpg" ||
          tipoDocumento == "JPG" ||
          tipoDocumento == "jpeg" ||
          tipoDocumento == "png" ||
          tipoDocumento == "gif" ||
          tipoDocumento == "bmp" ||
          tipoDocumento == "webp" ||
          tipoDocumento == "svg" ||
          tipoDocumento == "tiff" ||
          tipoDocumento == "avif" ||
          tipoDocumento == "mov" ||
          tipoDocumento == "mp4"
        ) {
          this.constitutiva.documentos[i].disabled = false;
        } else {
          this.constitutiva.documentos[i].disabled = true;
        }
      }
    },

    previewDocumento(item) {
      this.currentDocumento = item;

      let pretipoDocumento = item.nombreFile.split(".");
      let tipoDocumento = pretipoDocumento[pretipoDocumento.length - 1];

      if (tipoDocumento === "pdf") {
        this.$refs["documento-modal-preview-pdf"].show();
      }
      if (
        tipoDocumento === "jpg" ||
        tipoDocumento === "JPG" ||
        tipoDocumento === "jpeg" ||
        tipoDocumento === "png" ||
        tipoDocumento === "gif" ||
        tipoDocumento === "bmp" ||
        tipoDocumento === "webp" ||
        tipoDocumento === "svg" ||
        tipoDocumento === "tiff" ||
        tipoDocumento === "avif"
      ) {
        this.$refs["documento-modal-preview-img"].show();
      }

      if (tipoDocumento === "docx") {
        this.$refs["documento-modal-preview-docx"].show();
      }

      if (tipoDocumento === "mov" || tipoDocumento === "mp4") {
        this.$refs["documento-modal-preview-video"].show();
      }
    },

    descargaFile(item) {
      const link = document.createElement("a");
      link.href = item + this.stgAccessKey;
      document.body.appendChild(link);
      link.click();
    },

    descargarExpedienteHandler() {
      this.descargarExpediente();
    },

    async descargarExpediente() {
      try {
        this.loading = true;

        const response = await FuncionesApi.descargarExpediente(1, this.constitutiva.id);

        saveAs(response, this.constitutiva.folio + ".zip");
      } catch (error) {
        console.error("Error downloading file:", error);
        this.showErrorToast("Error al descargar el archivo.");
      } finally {
        this.loading = false;
      }
    },

    descargarDocumentoHandler(documento) {
      this.descargarDocumento(documento);
    },

    async descargarDocumento(documento) {
      try {
        this.loading = true;

        const response = await FuncionesApi.descargarDocumento(documento.id);
        let filename = documento.nombre;

        if (!documento.nombre) {
          filename = documento.documento.split("/").pop();
        }

        saveAs(response, filename);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.showErrorToast("Error al descargar el archivo.");
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>
